import {
  LS_BASKET,
  LS_BASKET_LAST_UPDATE,
  API_URL,
  CLIENT_TOKEN,
  CLIENT_ID,
  CLIENT_SECRET,
  INVALID_GRANT_ERROR,
  REFRESH_TOKEN_EXPIRED_ERROR,
  REFRESH_TOKEN_EXPIRED_ERROR_DESCRIPTION,
  CUSTOM_PROGRAM_STEP_ONE_TITLE,
  CUSTOM_PROGRAM_STEP_TWO_TITLE,
  CUSTOM_PROGRAM_STEP_THREE_TITLE,
  CUSTOM_PROGRAM_STEP_FOUR_TITLE
} from "./constants";
import axios from "axios";

export const parseJwt = token => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const refreshToken = async refreshToken => {
  // const refreshToken = localStorage.getItem("REFRESH_TOKEN");
  const response = await axios
    .get(API_URL + CLIENT_TOKEN + "oauth/v2/token", {
      params: {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        redirect_uri: "http://monstade.fr",
        grant_type: "refresh_token",
        refresh_token: refreshToken
      }
    })
    .catch(reason => {
      console.error(reason.response);
      if (reason.response) {
        if (reason.response.status === 400) {
          if (reason.response.data.error === INVALID_GRANT_ERROR) {
            localStorage.removeItem("ACCESS_TOKEN");
            localStorage.removeItem("REFRESH_TOKEN");

            if (
              reason.response.data.error_description ===
              REFRESH_TOKEN_EXPIRED_ERROR_DESCRIPTION
            ) {
              return {
                error: "refresh_token_expired",
                error_description: "Votre session a expiré"
              };
            }
          }
          return { error: "Identifiants inconnus" };
        } else {
          return { error: "Une erreur s'est produite" };
        }
      }
    });
  if (response) {
    console.log("suup", response);
    if (response.error && response.error === "refresh_token_expired") {
      // this.state.setLoginStatus(false)
      return { status: "ko" };
    }
    if (response.data) {
      const { data } = response;

      localStorage.setItem("ACCESS_TOKEN", data["access_token"]);
      localStorage.setItem("REFRESH_TOKEN", data.refresh_token);
      return { status: "ok" };
    }
  }
};

export const getLoaderColor = color => {
  switch (color) {
    case "yellow":
      return "#ffcb05";
    // TODO other cases

    default:
      break;
  }
};
export const getColor = color => {
  switch (color) {
    case "yellow":
      return "#ffcb05";

    case "green":
      return "#2bb673";

    case "light-blue":
      return "#00aeef";

    default:
      return "#00aeef";
  }
};

export const getCustomProgramStepLabel = step => {
  switch (step) {
    case 1:
      return CUSTOM_PROGRAM_STEP_ONE_TITLE;

    case 2:
      return CUSTOM_PROGRAM_STEP_TWO_TITLE;

    case 3:
      return CUSTOM_PROGRAM_STEP_THREE_TITLE;

    case 4:
      return CUSTOM_PROGRAM_STEP_FOUR_TITLE;

    default:
      return "";
  }
};

export const getCustomProgramNextStepLabel = step => {
  switch (step) {
    case 1:
      return CUSTOM_PROGRAM_STEP_ONE_TITLE;

    case 2:
      return CUSTOM_PROGRAM_STEP_TWO_TITLE;

    case 3:
      return CUSTOM_PROGRAM_STEP_THREE_TITLE;

    case 4:
      return CUSTOM_PROGRAM_STEP_FOUR_TITLE;

    default:
      return "";
  }
};

export const formatCustomProgramProduct = (product, quantifier) => {
  product.price = product.duration.offers[0].price;
      product.name += ` ${
        product.subtitle ? product.subtitle.toLowerCase() : ""
      } - ${product.duration.offers[0].quantity} ${quantifier}`;

      return product;
}
